/** @format */
import axios from 'axios';

/**
 * Get poll results
 *
 * @param {Object} data Data
 *
 * @return Promise for resolve, reject
 */
export const getPollStatus = function (data) {
    return axios
        .post('/poll/status', data.data, {
            headers: {
                'X-NA-Skip-Auth-Redirect': '1'
            }
        })
        .then((response) => response.data);
};

/**
 * Vote on a poll
 *
 * @param {Object} data Data
 *
 * @return Promise for resolve, reject
 */
export const vote = function (data) {
    return axios
        .post('/poll/vote', data.data, {
            headers: {
                'X-NA-Skip-Auth-Redirect': '1'
            }
        })
        .then((response) => response.data);
};

/**
 * Unvote on a poll
 *
 * @param {Object} data Data
 *
 * @return Promise for resolve, reject
 */
export const unvote = function (data) {
    return axios
        .post('/poll/unvote', data.data, {
            headers: {
                'X-NA-Skip-Auth-Redirect': '1'
            }
        })
        .then((response) => response.data);
};

/**
 * Approve a text response in a poll
 *
 * @param {Object} data Data containing post_id, poll_response_id, question_id, response_text
 *
 * @return Promise for resolve, reject
 */
export const approveTextResponse = function (data) {
    return axios
        .post('/poll/approve-text-response', data)
        .then((response) => response.data);
};

/**
 * Unapprove a text response in a poll
 *
 * @param {Object} data Data containing post_id, poll_response_id, question_id
 *
 * @return Promise for resolve, reject
 */
export const unapproveTextResponse = function (data) {
    return axios
        .post('/poll/unapprove-text-response', data)
        .then((response) => response.data);
};
